var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { matchPath, Navigate, Outlet, useLocation } from 'react-router-dom';
import { RoleType } from 'app/common/types/server-api-dtos';
import { getRegistrationRoutes, getUserSelfRegistrationRoutes } from 'app/common/constants/routes';
import { userService } from 'app/common/utils/user-service';
import { ROUTES } from 'common/routing';
export var OnlyCreateCompany = function (_a) {
    var _b = _a.withOutlet, withOutlet = _b === void 0 ? false : _b;
    var pathname = useLocation().pathname;
    var isCompanyCreator = userService.hasRole(RoleType.CompanyCreator);
    var allowedPaths = useMemo(function () {
        return __spreadArray(__spreadArray([], getRegistrationRoutes(), true), getUserSelfRegistrationRoutes(), true).map(function (route) {
            return route.path.startsWith('/') ? route.path : "/".concat(route.path);
        });
    }, []);
    var isAllowedPage = allowedPaths.some(function (path) { return !!matchPath({ path: path, end: true }, pathname); });
    if (isAllowedPage) {
        return _jsx(Outlet, {});
    }
    if (isCompanyCreator) {
        return _jsx(Navigate, { replace: true, to: ROUTES.REGISTRATION, state: { from: pathname } });
    }
    return withOutlet ? _jsx(Outlet, {}) : null;
};
